/// <reference path="../../../../Scripts/typings/jquery/jquery.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/home/viewmodels/help',["require", "exports", "durandal/app", "common/string", "common/viewmodelbase", "services/settings"], function (require, exports, App, StringExtensions, ViewModel, Configuration) {
    "use strict";
    var HelpViewModel = (function (_super) {
        __extends(HelpViewModel, _super);
        //#region ctor
        function HelpViewModel() {
            _super.call(this);
            //#endregion
            this.showHost = false;
            this.isloading = true;
            this.title = $.t("app:modules.home.headline_title", { ifMissing: "home" });
            ko.track(this, ["uri", "showHost", "isloading"]);
        }
        HelpViewModel.prototype.onActivated = function (context) {
            return Q(true);
        };
        HelpViewModel.prototype.attached = function () {
            var _this = this;
            App.trigger("pushCurrentNode", function (node) { return _this.embed(node); });
        };
        HelpViewModel.prototype.embed = function (item) {
            var isTenant = StringExtensions.contains("Account.Principal.current.memberType", "stb_");
            var link = this.buildLink(item);
            var url = Configuration.Settings.getUrlScheme() + (isTenant ? "://help.one-click.de/OneClickHelpAdvisor/en/" : "://help.one-Click.de/OneClickHelp/en/");
            link = link.replace("local://help?url=", url);
            window.open(link, "_blank");
        };
        HelpViewModel.prototype.buildLink = function (item) {
            if (item.type === "ApplicationLink" && item.raw.data.route != null) {
                return item.raw.data.route;
            }
            var app = item.type === "Application"
                ? item.application
                : item.parent.application;
            return app.link;
        };
        return HelpViewModel;
    }(ViewModel.ViewModelBase));
    return HelpViewModel;
});

